export default __webpack_public_path__ + "static/wallpaper-1-mb-c5ec350010647bca65d6c825cafb9fd8.png";